import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Hidden } from "@mui/material";
import { fetchData } from "../../helpers/getData/fetchData";
import { NoData } from "./NoData";
import { LPByStartup } from "./LPByStartup";

export const LPTable = ({ fundId, percentage, generalSheet }) => {
  const { t } = useTranslation("global");
  const [distributionList, setDistributionList] = useState("isLoading");

  useEffect(() => {
    fetchData(setDistributionList, `/fundDistributions?id=${fundId}`, t);
  }, [t, fundId]);

  return (
    <Hidden mdDown>
      {distributionList !== "isLoading" && distributionList.length > 0 ? (
        <LPByStartup
          percentage={percentage}
          distributionList={distributionList}
          generalSheet={generalSheet}
        />
      ) : (
        <NoData distributionList={distributionList} />
      )}
    </Hidden>
  );
};
